import { useDispatch, useSelector } from "react-redux";
import { submitPrivacyAgreeApi } from "../../../api/privacyAgreeTerm/submitPrivacyAgreeApi";
import {
  initState,
  submitData,
} from "../../../modules/reducers/agreePrivacyTerm/agreePrivacy";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const usePrivacyAgree = () => {
  const dispatch = useDispatch();
  const api = submitPrivacyAgreeApi();
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const status = useSelector((state) => state.agreePrivacy.status);

  const loading = useSelector((state) => state.agreePrivacy.loading);

  const navigate = useNavigate();

  const submit = () => {
    const data = {
      service_name: "LOST_AND_FOUND",
      user_id: userId,
    };
    dispatch(submitData({ ...api, data }));
  };

  useEffect(() => {
    if (status === true) {
      dispatch(initState());
      navigate("/lost/register-lost-item", { replace: true });
    }
  }, [status]);
  return { submit, loading };
};

export default usePrivacyAgree;
